import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'underdevelopment',
  templateUrl: './underdevelopment.component.html',
  styleUrls: ['./underdevelopment.component.css']
})
export class UnderdevelopmentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
